import React, { Component } from 'react';
import { Popover, ArrowContainer } from 'react-tiny-popover';
import './PopOverMenu.scss';
import ImgTag from '../ImgTag';
import menuDotIcon from '../../../../assets/icons/ic_more_horzt_white.png';
// import menuRefreshIcon from '../../../../assets/icons/ic_reset_blue.png';
// import menuEditIcon from '../../../../assets/icons/ic_edit_light_grey.png';
import menuDeleteIcon from '../../../../assets/icons/ic_delete_lite_grey.png';
import CLONE_CONFIG from '../../../../assets/icons/ic_duplicate_config_grey.png';
import COPY_PATH from '../../../../assets/icons/ic_duplicate_grey.png';
import Button from '../Button';
import { Modal } from "react-ui-lib";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { updateBotValue, successGenericDataGet, updateCreateMenuVisiblity, updateCreateMenuData, updateCreateMenuType } from '../../../Redux/Actions/uiActions';
import { copyToClipboard } from '../../../Utils/index';
class PopOverMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isGeneric: false,
            popoverObj: false,
            isOpen: false,
            copyState: false,
            obejctTypeArr: [
                {name: 'switch-toggle', value: 'switchtoggle'},
                {name: 'radio-toggle', value: 'radiotoggle'},
                {name: 'text-field', value: 'textfield'},
                {name: 'number-field', value: 'numberfield'},
                {name: 'color-array-field', value: 'groupfield'},
                {name: 'image-array-field', value: 'groupfield'},
                {name: 'input-array-group-field', value: 'groupfield'},
                {name: 'group', value: 'groupfield'},
                {name: 'optional-group', value: 'objectGroupfield'},
                {name: 'object-group', value: 'objectGroupfield'}
            ]
        }
    }

    componentDidMount() {
        const firstParam = this.props.location.pathname.split('/')[1];
        if (firstParam === 'genericconfig' && !this.state.isGeneric) {
            this.setState({ isGeneric: true })
        } else if (this.state.isGeneric) {
            this.setState({ isGeneric: false })
        }
    }

    toggleDeleteModal = (currState = true ) => {
        const { isOpen } = this.state;
        if (!currState) {
            document.getElementsByTagName('body')[0].style.overflow = 'auto';
            this.setState({ isOpen: false });
        } else {
            document.getElementsByTagName('body')[0].style.overflow = isOpen
                ? 'auto'
                : 'hidden';
            this.setState(prevState => ({
                isOpen: !prevState.isOpen
            }));
        }
    };

    updateOnLocation = (dataKey, parentArray) => {
        let currentData = this.state.isGeneric ? this.props.genericBotData : this.props.editableBotData;
        if (parentArray.length === 2) {
            if (parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS') {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData[parentArray[0]].splice([parentArray[1]], [parentArray[1]] + 1)
                } else {
                    delete currentData[parentArray[0]][parentArray[1]];
                }
            } else {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData.UI_OPTIONS[parentArray[0]].splice([parentArray[1]], [parentArray[1]] + 1)
                } else {
                    delete currentData.UI_OPTIONS[parentArray[0]][parentArray[1]];
                }
            }
        } else if (parentArray.length === 3) {
            if (parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[1] === 'TESTING_PAGE_SETTINGS' || parentArray[1] === 'CUSTOMISE_YOUR_BOT') {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData[parentArray[0]][parentArray[1]].splice([parentArray[2]], [parentArray[2]] + 1)
                } else {
                    delete currentData[parentArray[0]][parentArray[1]][parentArray[2]];
                }
            } else {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData.UI_OPTIONS[parentArray[0]][parentArray[1]].splice([parentArray[2]], [parentArray[2]] + 1)
                } else {
                    delete currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]];
                }
            }
        } else if (parentArray.length === 4) {
            if (parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[1] === 'TESTING_PAGE_SETTINGS' || parentArray[1] === 'CUSTOMISE_YOUR_BOT') {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData[parentArray[0]][parentArray[1]][parentArray[2]].splice([parentArray[3]], [parentArray[3]] + 1)
                } else {
                    delete currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]];
                }
            } else {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]].splice([parentArray[3]], [parentArray[3]] + 1)
                } else {
                    delete currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]];
                }
            }
        } else if (parentArray.length === 5) {
            if (parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[1] === 'TESTING_PAGE_SETTINGS' || parentArray[1] === 'CUSTOMISE_YOUR_BOT') {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]].splice([parentArray[4]], [parentArray[4]] + 1)
                } else {
                    delete currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]];
                }
            } else {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]].splice([parentArray[4]], [parentArray[4]] + 1)
                } else {
                    delete currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]];
                }
            }
        } else if (parentArray.length === 6) {
            if (parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[1] === 'TESTING_PAGE_SETTINGS' || parentArray[1] === 'CUSTOMISE_YOUR_BOT') {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]].splice([parentArray[5]], [parentArray[5]] + 1)
                } else {
                    delete currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]];
                }
            } else {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]].splice([parentArray[5]], [parentArray[5]] + 1)
                } else {
                    delete currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]];
                }
            }
        } else if (parentArray.length === 7) {
            if (parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[1] === 'TESTING_PAGE_SETTINGS' || parentArray[1] === 'CUSTOMISE_YOUR_BOT') {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[5]].splice([parentArray[6]], [parentArray[6]] + 1)
                } else {
                    delete currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]];
                }
            } else {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]].splice([parentArray[6]], [parentArray[6]] + 1)
                } else {
                    delete currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]];
                }
            }
        } else if (parentArray.length === 8) {
            if (parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[1] === 'TESTING_PAGE_SETTINGS' || parentArray[1] === 'CUSTOMISE_YOUR_BOT') {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]].splice([parentArray[7]], [parentArray[7]] + 1)
                } else {
                    delete currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]];
                }
            } else {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]].splice([parentArray[7]], [parentArray[7]] + 1)
                } else {
                    delete currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]];
                }
            }
        } else if (parentArray.length === 9) {
            if (parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[1] === 'TESTING_PAGE_SETTINGS' || parentArray[1] === 'CUSTOMISE_YOUR_BOT') {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]].splice([parentArray[8]], [parentArray[8]] + 1)
                } else {
                    delete currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]];
                }
            } else {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]].splice([parentArray[8]], [parentArray[8]] + 1)
                } else {
                    delete currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]];
                }
            }
        } else if (parentArray.length === 10) {
            if (parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[1] === 'TESTING_PAGE_SETTINGS' || parentArray[1] === 'CUSTOMISE_YOUR_BOT') {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]].splice([parentArray[9]], [parentArray[9]] + 1)
                } else {
                    delete currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]][parentArray[9]];
                }
            } else {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]].splice([parentArray[9]], [parentArray[9]] + 1)
                } else {
                    delete currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]][parentArray[9]];
                }
            }
        } else if (parentArray.length === 11) {
            if (parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[1] === 'TESTING_PAGE_SETTINGS' || parentArray[1] === 'CUSTOMISE_YOUR_BOT') {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]][parentArray[9]].splice([parentArray[10]], [parentArray[10]] + 1)
                } else {
                    delete currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]][parentArray[9]][parentArray[10]];
                }
            } else {
                if (typeof parentArray[parentArray.length - 1] === 'number') {
                    currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]][parentArray[9]].splice([parentArray[10]], [parentArray[10]] + 1)
                } else {
                    delete currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]][parentArray[9]][parentArray[10]];
                }
            }
        }
        return currentData;
    }

    onDeleteConfirm = () => {
        let parentArray = this.props.parent;
        if (parentArray.length) {
            let tempArr = [];
            parentArray.forEach((elm, i) => {
                if (elm.indexOf('Object ') > -1) {
                    let searchedElem = elm.slice(7, 8);
                    searchedElem = parseInt(searchedElem) - 1;
                    tempArr.push('VALUE');
                    tempArr.push(searchedElem);
                } else {
                    tempArr.push(elm);
                }
            });
            parentArray = tempArr;
        }
        this.state.isGeneric ?
            this.props.successGenericDataGet(this.updateOnLocation(parentArray[parentArray.length - 1], parentArray)) :
            this.props.updateBotValue(this.updateOnLocation(parentArray[parentArray.length - 1], parentArray), new Date().getTime());

        this.toggleDeleteModal();
    }

    onCancelCallback = () => {
        this.toggleDeleteModal();
    };

    renderContent = (formType) => {
        return (
            <div className='delete-modal-body'>Please confirm to delete the object</div>
        );
    };

    addButtonImage = (imageSrc) => {
        return (
            <span className='eb-icon-btn-image'>
                <ImgTag
                    className='image'
                    src={imageSrc}
                    alt='Add'
                />
            </span>
        );
    }

    converParentArrToString = (tempArr, type) => {
        let tempStr = '';
        const tempType = type === 'copy' ? '.' : ' > '
        tempArr.forEach((elm, i)=>{
            if(!isNaN(elm)) {
                tempStr += '[' + elm + ']';
            } else if(isNaN(elm) && tempArr[i+1] && isNaN(tempArr[i+1])) {
                tempStr += elm + tempType;
            } else {
                tempStr += elm;
            }
        });
        return tempStr;
    }

    render() {
        const { isOpen } = this.state;
        const header = {
            title: 'Delete Confirmation',
            closeOnOutsideClick: true,
            // isRemoveCloseIcon : true,  // send if needed to hide close icon on header
            style: {
                // backgroundColor: '#FCF2F4'
            }
        };
        const footer = {
            onSubmit: this.onDeleteConfirm,
            onCancel: this.onCancelCallback,
            submitText: 'Delete',
            cancelText: 'Cancel',
            customStyle: {
                // backgroundColor:'blue'
                justifyContent: 'flex-end'
            },
            disableSubmit: false,
            disableCancel: false
        };
        const customStyle = {
            maxWidth: '500px'
        };

        const { groupConfDetails, tempdata } = this.props;

        // console.log(this.props, this.props.parent);
        return (
            <>
                <Popover
                    isOpen={this.state.popoverObj}
                    positions={['bottom', 'left', 'right']}
                    reposition={true}
                    padding={5}
                    parentElement={document.getElementById('mainBodySection')}
                    onClickOutside={() => {
                        this.setState({ popoverObj: false })
                    }}
                    containerClassName='popover-menu-outer-wrapper'
                    content={({ position, childRect, popoverRect }) => (
                        <div className='popover-wrapper popover-menu-wrapper popover-align-left'
                            onClick={() => {
                                this.setState({ popoverObj: !this.state.popoverObj });
                            }}
                        > <ArrowContainer
                            position={position}
                            childRect={childRect}
                            popoverRect={popoverRect}
                            arrowColor={"#fff"}
                            arrowSize={12}
                            arrowStyle={{ opacity: 1 }}
                        >
                                <div className='popover-block'>
                                    <span className={'copy-flash-message' + (this.state.copyState ? ' active': '')}>Copied</span>
                                    <p className='popover-description'>
                                        {this.props.groupDesc ? this.props.groupDesc : 'NA'}
                                    </p>
                                    <div className='config-value-info'>
                                        <label>Config Value:</label>
                                        <Button
                                            className='eb-icon-btn-style config-copy-btn'
                                            type='button'
                                            otherAttribs={{ title: 'Copy'}}
                                            value={this.addButtonImage(COPY_PATH)}
                                            buttonOnClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                copyToClipboard(tempdata && tempdata.executableArray ? this.converParentArrToString(tempdata.executableArray, 'copy') : groupConfDetails.replace(/ > /g, '.'), () => {
                                                    this.setState({ copyState: true });
                                                    setTimeout(() => {
                                                        this.setState({ copyState: false });
                                                    }, 2000);
                                                })
                                            }}
                                        />
                                        <p className='config-value'>{groupConfDetails ? groupConfDetails : this.props.groupTitle}</p>
                                    </div>
                                    { (this.props.parent.length >= 4 && (this.props.parent[2] === 'RATING' && this.props.parent[3] === 'NUMBERS')) ? null :
                                    <div className='icon-button-wrapper go-float-right'>
                                        {/* <Button
                                    className = 'eb-icon-btn-style'
                                    type = 'button'
                                    otherAttribs = {{title: 'Delete', data: `${groupConfDetails.replace(/ > /g, ',')}`}}
                                    value = {this.addButton(menuRefreshIcon)}
                                /> */}
                                        {/* <Button
                                    className = 'eb-icon-btn-style'
                                    type = 'button'
                                    otherAttribs = {{title: 'Edit', data: `${groupConfDetails.replace(/ > /g, ',')}`}}
                                    value = {this.addButton(menuEditIcon)}
                                    buttonOnClick = {(e) => {
                                        console.log(e);
                                    }}
                                /> */}
                                        {/* <Button
                                            className='eb-icon-btn-style'
                                            type='button'
                                            otherAttribs={{ title: 'Clone'}}
                                            value={this.addButtonImage(CLONE_CONFIG)}
                                            buttonOnClick={(e) => {
                                                console.log(this.props);
                                                this.props.updateCreateMenuVisiblity(true);
                                                this.props.updateCreateMenuType('Clone');
                                                let tempTypeObj = this.state.obejctTypeArr.find((elm) => elm.name === this.props.groupType )
                                                let tempObj = {
                                                    parentArray: this.props.parent,
                                                    selectedMenuType: tempTypeObj.value,
                                                    createMenuData: this.props.tempdata?.data ? this.props.tempdata.data : this.props.tempdata,
                                                    modalType: 'Clone'
                                                }
                                                console.log('tempObj', tempObj);
                                                this.props.updateCreateMenuData(tempObj);
                                            }}
                                        /> */}
                                        <Button
                                            className='eb-icon-btn-style'
                                            type='button'
                                            otherAttribs={{ title: 'Delete', data: `${groupConfDetails.replace(/ > /g, ',')}` }}
                                            value={this.addButtonImage(menuDeleteIcon)}
                                            buttonOnClick={(e) => {
                                                this.toggleDeleteModal();
                                            }}
                                        />
                                    </div>
                                    }
                                </div>
                            </ArrowContainer>
                        </div>
                    )}
                >
                    <button className='eb-icon-btn-style more-options-btn' type='button' title='More Options' onClick={() => { this.setState({ popoverObj: !this.state.popoverObj }); }}>
                        <span className='eb-icon-btn-image'>
                            <ImgTag
                                className='image'
                                src={menuDotIcon}
                                alt='More'
                            />
                        </span>
                    </button>
                </Popover>
                <div>
                    <Modal
                        isOpen={isOpen}
                        onClose={() => { this.toggleDeleteModal(false) }}
                        header={header}
                        footer={footer}
                        customStyle={customStyle}
                    >
                        {this.renderContent()}
                    </Modal>
                </div>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        editableBotData: state.UiReducer && state.UiReducer.editableBotData ? state.UiReducer.editableBotData : {},
        genericBotData: state.UiReducer && state.UiReducer.genericBotData ? state.UiReducer.genericBotData : {}
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        updateBotValue,
        successGenericDataGet,
        updateCreateMenuVisiblity,
        updateCreateMenuData,
        updateCreateMenuType
    },
        dispatch
    );
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PopOverMenu));